import React from 'react';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';
const Token = props => {
  const urlQuery = queryString.parse(props.location.search);
  if (urlQuery.t) {
    console.log(urlQuery.t);
  }
  return /*#__PURE__*/React.createElement(Redirect, {
    to: {
      pathname: "/login",
      state: {
        fwdToken: urlQuery.t
      }
    }
  });
};
export default Token;